import React from 'react';
import { BiasTest } from '../../../components/bias/BiasTest';

export const questions = [
  {
    question: "If all roses are flowers, and some flowers fade quickly, can we conclude that all roses fade quickly?",
    options: [
      "Yes, this is a valid conclusion",
      "No, this is not a valid conclusion",
      "We need more information about specific types of roses",
      "The premises are contradictory"
    ],
    correctOption: 1,
    explanation: "This tests your understanding of syllogistic reasoning. Just because some flowers fade quickly doesn't mean all roses (which are flowers) fade quickly. This is a common logical fallacy."
  },
  {
    question: "If no cats are dogs, and all dogs are mammals, what can we conclude about cats?",
    options: [
      "Cats are not mammals",
      "Cats are mammals",
      "We cannot conclude anything about cats being mammals",
      "Cats and dogs must be different types of mammals"
    ],
    correctOption: 2,
    explanation: "This tests your ability to avoid drawing unwarranted conclusions. The premises only tell us about the relationship between cats and dogs, and dogs and mammals."
  },
  {
    question: "If it's raining, the ground is wet. The ground is wet. Must it be raining?",
    options: [
      "Yes, it must be raining",
      "No, there could be other reasons for the wet ground",
      "We need to know if it rained recently",
      "Yes, because wet ground implies rain"
    ],
    correctOption: 1,
    explanation: "This tests your understanding of conditional logic. Just because A implies B, doesn't mean B implies A. The ground could be wet for many reasons other than rain."
  },
  {
    question: "All students in the class speak English. Sarah is in the class. What can we conclude?",
    options: [
      "Sarah speaks English",
      "Sarah only speaks English",
      "Sarah speaks English and possibly other languages",
      "We need more information about Sarah's language abilities"
    ],
    correctOption: 2,
    explanation: "This tests your ability to make valid deductions. We can conclude Sarah speaks English (as all students do), and she may or may not speak other languages."
  }
];

interface LogicalTestProps {
  answers: number[];
  onAnswerSelect: (questionIndex: number, answerIndex: number) => void;
}

export const LogicalTest: React.FC<LogicalTestProps> = ({
  answers,
  onAnswerSelect,
}) => {
  return (
    <div className="space-y-8">
      {questions.map((question, index) => (
        <BiasTest
          key={`question-${index}`}
          test={{
            questions: [question]
          }}
          variant="transparent"
          onAnswerSubmit={(isCorrect: boolean, selectedOptionIndex?: number) => {
            if (selectedOptionIndex !== undefined) {
              onAnswerSelect(index, selectedOptionIndex);
            }
          }}
        />
      ))}
    </div>
  );
}; 